import { BaseModel } from "./BaseModel";
import { AxiosErr } from "../Contracts/IMdels";

export class BankAccountModel extends BaseModel {
  RouteName = "BankAccount";
  protected AuthState: boolean = true;
}
